import React from 'react';
import {Link} from 'react-router';
import fileDownload from 'js-file-download';
import { checkServerLive } from 'constants/config';
import {downloadFile} from 'components/utils';
import { get, isArray } from 'lodash'
import classnames from 'classnames';

export default class RowItemDocumentDetail extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      disable: false
    }
  }

  handleDownload() {
    try {
      this.setState({disable: true});
      const taiLieuVanThu = this.props.item.listTaiLieuVanThus[0];
      downloadFile(taiLieuVanThu.duongDan, taiLieuVanThu.tenFile, null, undefined, true);
    } catch (err) {
      console.error(err);
    } finally {
      setTimeout(function () {
        this.setState({disable: false});
      }.bind(this), 2000);
    }
  }
 
  render() {
    const taiLieuVanThu =  isArray(get(this.props.item, 'listTaiLieuVanThus')) && this.props.item.listTaiLieuVanThus.length > 0 ? get(this.props.item, 'listTaiLieuVanThus[0]') : null;
    const { donViXuLyInfo, tenInfo } = this.props.item;
    if (!this.props.item) {
      return null;
    }
    return (
      <tr>
        <td>{this.props.count || ''}</td>
        <td>{get(donViXuLyInfo, 'ten')}</td>
        <td>{get(tenInfo, 'ten')}</td>
        <td>
          { taiLieuVanThu &&
            <Link
              className={classnames('txt-underline', {
                isDisable: this.state.disable,
              })}
              onClick={checkServerLive ? this.handleDownload.bind(this) : fileDownload.bind(this, taiLieuVanThu.duongDan, taiLieuVanThu.tenFile)}
            >
              {get(taiLieuVanThu, 'tenFile')}
            </Link>
          }
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/tra-cuu/RowItemDocumentDetail.jsx